import React, { useContext } from "react";
import ReactHtmlParser from "react-html-parser";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { CanvasContext, ICanvasComponent } from "../canvasContext.tsx";
import { fontList, sizeList } from "./Toolbar.tsx";

const Size = Quill.import("attributors/style/size");
Size.whitelist = sizeList.slice();
for (let n = 6; n <= 200; n += 1) {
  const label = `${n}px`;
  if (!Size.whitelist.includes(label)) Size.whitelist.push(label);
}

const Font = Quill.import("attributors/style/font");
Font.whitelist = fontList.slice();

export function allowCanvasFont(name: string) {
  const font = String(name || "").replace(/["']/g, "").trim();
  if (!font) return "Arial";
  if (!Font.whitelist.includes(font)) Font.whitelist.push(font);
  return font;
}

Quill.register(Font, true);
Quill.register(Size, true);

const TextElement = (props: ICanvasComponent) => {
  const { content, id, isReadOnly } = props;
  const { actions } = useContext(CanvasContext);
  const editorRef = React.useRef(null);

  const updateEditorValue = (value: string) => {
    actions?.updateCanvasData({ id, content: value });
  };

  const modules = {
    toolbar: "#toolbar"
  };

  return (
    <>
      <div>
        {isReadOnly ? (
          <div
            className="ql-editor"
            style={{
              padding: 0
            }}
          >
            {ReactHtmlParser(content || "")}
          </div>
        ) : (
          <ReactQuill
            ref={editorRef}
            readOnly={isReadOnly}
            theme="snow"
            className="quill-container"
            modules={modules}
            value={content}
            onChange={updateEditorValue}
          />
        )}
      </div>
    </>
  );
};

export default TextElement;
